export default __webpack_public_path__ + "static/media/planet1.618c9820.png";